var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"idea"}},[_c('div',{staticClass:"idea-box"},[_c('img',{attrs:{"src":require("../../../assets/image/idea.jpg"),"alt":""}})])])}]

export { render, staticRenderFns }